import styled from 'styled-components';

export const PrivacyPolicyContainer = styled.section`
  /* border: 2px solid rebeccapurple; */
  margin-bottom: ${({ theme }) => theme.spacing.m};
  h3 {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }
  h4 {
    margin-bottom: ${({ theme }) => theme.spacing.xs};
    margin-left: ${({ theme }) => theme.spacing.s};
  }
  p {
    margin-bottom: ${({ theme }) => theme.spacing.xs};
    margin-left: ${({ theme }) => theme.spacing.m};
  }
  li {
    margin-bottom: ${({ theme }) => theme.spacing.xxs};
    margin-left: ${({ theme }) => theme.spacing.xxl};
  }
  a {
    color: ${({ theme }) => theme.colors.orange5};
    text-decoration: underline;
    text-transform: lowercase;
    letter-spacing: 0;
  }
`;
